function printOrder(printDiv, orderNumber, site_url) {
	var w = window.open('ABS', 'PRINT', '');
	var logo = document.querySelector("img.mega-menu-logo").src;
	var sitedescription = document.querySelector("p.site-description").innerHTML;
	w.document.write('<html><head>');

	w.document.write('<link rel="icon" href="'+ logo +'" sizes="any" type="image/svg+xml">');
	w.document.write('<img src="'+ logo +'" width="25" height="40"><title>'+ sitedescription +'</title>');
	/* if(orderNumber != 'undefined'){
  w.document.write('<html><head><title>Order Number '+ orderNumber +'</title>');
	}else{
		w.document.write('<html><head><title>Thank you, Order received</title>');
	} */
  w.document.write('<link type="text/css" rel="stylesheet"  href="'+ site_url +'/wp-content/themes/storefront/style.css">');
  w.document.write('<link type="text/css" rel="stylesheet"  href="'+ site_url +'/wp-content/themes/storefront-child/assets/styles/main.css">');
  w.document.write('<style type="text/css">');

	// Order Info
  w.document.write('.woocommerce-order-overview__list{flex-direction: row; padding: 1rem 1.5rem; background-color:#f1f5f9; -webkit-print-color-adjust: exact; color-adjust: exact;} dl.woocommerce-order-overview__list dd{color:#1D4F91; font-weight:500; color-adjust: exact;} dl.woocommerce-order-overview__list dt{ font-weight:500;} .woocommerce-order-overview__item:not(:first-child) { border-left: 1px solid #e5ebf3; padding-left: 0.75rem; color-adjust: exact; }');

  // Heading
  w.document.write('.woocommerce-my-account .content-box__body{ display: flex; flex-direction: column;} .content-box__section-title{color:#1d4f91; color-adjust: exact;} table:not(.has-background) thead tr th{ background-color:#f1f5f9; color:#323232; -webkit-print-color-adjust: exact; color-adjust: exact; }');

  // Order details
  w.document.write('.shop-table--responsive tbody tr{display:table-row;} .shop-table--responsive thead {display: table-header-group;} .woocommerce-order-details .shop-table thead tr th.product-thumbnail {width: 17.5%;} .woocommerce-order-details .shop-table thead tr th.product-description{width:30%;} .shop-table--responsive tbody tr td.product-description, .shop-table--responsive tbody tr td.product-thumbnail{margin-bottom:.5rem;} .shop-table td{padding:1.75rem 1rem 1rem;} .shop-table--responsive tbody tr td[data-title]:before{ content: none; } .woocommerce-order-details .shop-table tbody tr td.product-quantity{padding:1.75rem 1rem 1rem;} ');
	 w.document.write('td.product-description ul {margin: 0;padding: 0;list-style-type: none;font-size: .875em;margin-top: 0.5rem;margin-bottom: -0.5rem; }');

  // Total detail
  w.document.write('.woocommerce-order-totals{flex-direction:row; background-color:#1d4f91; -webkit-print-color-adjust: exact; padding: 0; color-adjust: exact; } .woocommerce-order-totals__item {display: block; margin: 0; padding: 1rem 1.5rem; color: #fff; color-adjust: exact;} .woocommerce-order-totals__items_4{min-width: 25%;} .woocommerce-order-totals__items_5 {min-width: 20%;} .woocommerce-order-totals dt{ font-size: 1rem; font-weight: 500;} .woocommerce-order-totals__item--highlighted{ background-color: #003976; -webkit-print-color-adjust: exact; color-adjust: exact;} .woocommerce-order-totals__item:not(:first-child) {border-left:1px solid hsla(0,0%,100%,.25); border-top: none; color-adjust: exact; } .woocommerce-order-details .shop-table { margin-bottom: 10px; }');

  // Shipping details
  w.document.write('.woocommerce-order-shipping p{display: flex;} .woocommerce-order-shipping.mt-8{ margin-top: 20px !important; }');

  // Tracking Information
  w.document.write('.order-actions .btn-secondary{background-color: #ce1141; color: #fff; -webkit-print-color-adjust: exact; color-adjust: exact; } .woocommerce-my-account .content-box__body p, .woocommerce-my-account .content-box__body .woocommerce_shipment_tracking{ order: -1; }');

  // Billing address
  w.document.write('.woocommerce-customer-details{-webkit-print-color-adjust: exact; color-adjust: exact; } .woocommerce-customer-details{ margin-top: 20px; } .woocommerce-customer-details { grid-gap: 1.5rem; display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); }');

  // Thankyou
  w.document.write('.woocommerce-order-intro__title.content-box__section-title{ margin-top: 20px; }');

  w.document.write('</style>');
  w.document.write('</head><body >');
  w.document.write('<div class="woocommerce-my-account-content woocommerce-my-account-order-details">');
  if(orderNumber != 'undefined'){
	w.document.write('<h2 class="content-box__section-title" style="margin-top: 20px;">Order Number '+ orderNumber +'</h2>');
  }
  w.document.write(document.getElementById(printDiv).innerHTML);
  w.document.write('</div>');

  setTimeout(function() { // wait until all resources loaded
    w.document.close(); // necessary for IE >= 10
    w.focus(); // necessary for IE >= 10
    w.print(); // change window to winPrint
    w.close(); // change window to winPrint
 }, 1000);


}


export {
  printOrder
};
